import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import React from 'react'
import { CustomObjectsList } from './CustomObjectsList'

interface CustomObjectsAdminSettingsProps {
  serviceId: IntegrationServiceId
}

export const CustomObjectsAdminSettings: React.FC<CustomObjectsAdminSettingsProps> = ({ serviceId }) => {
  const { isAccountLoading } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountLoading) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container>
      <Row className='mb-5'>
        <Col>
          <h3 className='mb-2'>Objects</h3>
          <div className='zocks-text-gray-600'>
            <p>
              Configure any {getIntegrationDisplayName(serviceId)} object Zocks can update from a meeting. Choose the fields to include for each object type,
              with an optional description to help your AI Assistant use them correctly.
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <CustomObjectsList serviceId={serviceId} />
      </Row>
    </Container>
  )
}
